export const breakpointEMs = {
  // 16px default font size * ...em
  // all vaules are em
  base: 1,
  mobile: 22, // ~352px
  mobileLandscape: 28, // ~448px
  tablet: 45, // ~720px
  tabletLandscape: 62, // ~992px
  desktop: 82, // 1312px
  screen: 115, // ~1840px
};
1